





















































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HelpItemSetting extends Vue {
  show = true
}
